'use client'

import { Logo } from '@/layouts/header/v1/components'
import { Box, Typography } from '@mui/material'
import { keyframes, styled } from '@mui/material/styles'
import { useEffect, useState } from 'react'

// Animation cho bounce effect
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`

// Styled component cho dot animation
export const BouncingDot = styled(Box)<{ delay?: number }>(({ theme, delay = 0 }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  animation: `${bounce} 1.8s infinite ease-in-out`,
  animationDelay: `${delay}s`,
  [theme.breakpoints.up('md')]: {
    width: 14,
    height: 14,
  },
  [theme.breakpoints.up('lg')]: {
    width: 16,
    height: 16,
  },
}))

export const LoadingScreen = () => {
  const [retry, setRetry] = useState(false)

  useEffect(() => {
    const id = setTimeout(() => {
      setRetry(true)
    }, 8000)
    return () => {
      clearTimeout(id)
    }
  }, [])

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'background.default',
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: {
            xs: 1.5,
            md: 2,
          },
        }}
      >
        <Typography variant="body2" sx={{ position: 'absolute', left: -10000 }}>
          Loading...
        </Typography>
        <Box sx={{ mr: 2, mb: 0.5 }}>
          <Logo href="#" />
        </Box>
        {/* Bouncing dots animation */}
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <BouncingDot delay={-0.45} />
          <BouncingDot delay={-0.3} />
          <BouncingDot delay={-0.15} />
          <BouncingDot delay={0} />
        </Box>
      </Box>
    </Box>
  )
}
